module.exports = __webpack_public_path__ + "static/home-hero2-7018ec12fc810962dbb47b7b707c0352.jpg";